function Tooltip(_ref) {
  var _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      isDisabled = _ref.isDisabled,
      title = _ref.title,
      _ref$container = _ref.container,
      container = _ref$container === void 0 ? 'body' : _ref$container,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'top' : _ref$placement,
      label = _ref.label,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      children = _ref.children,
      _ref$destroyOnRender = _ref.destroyOnRender,
      destroyOnRender = _ref$destroyOnRender === void 0 ? false : _ref$destroyOnRender;
  var containerRef = useRef(null);
  var _apricot$utils$keys = apricot().utils.keys,
      SPACE = _apricot$utils$keys.SPACE,
      ENTER = _apricot$utils$keys.ENTER,
      ESC = _apricot$utils$keys.ESC;
  useEffect(function () {
    $(containerRef.current).tooltip({
      container: container,
      placement: placement
    });
    return function () {
      destroyOnRender && $(containerRef.current).tooltip('destroy');
    };
  });
  return React.createElement(tag, {
    ref: containerRef,
    'data-toggle': 'tooltip',
    'data-original-title': title,
    onFocus: function onFocus() {
      return $(containerRef.current).tooltip('show');
    },
    onBlur: function onBlur() {
      return $(containerRef.current).tooltip('hide');
    },
    onKeyDown: function onKeyDown(e) {
      if (e.keyCode === SPACE || e.keyCode === ENTER) {
        $(containerRef.current).tooltip('show');
      }

      if (e.keyCode === ESC) {
        $(containerRef.current).tooltip('hide');
      }
    },
    'aria-label': label || "".concat(title, " label"),
    role: 'button',
    'aria-disabled': isDisabled,
    tabIndex: 0,
    style: style
  }, children);
}

export default Tooltip;